import React from 'react';
import { Link } from 'react-router-dom';
import { Textfit } from 'react-textfit';
import { Button } from 'devextreme-react';
import { Col, Grid, Row, Panel, Accordion } from 'react-bootstrap';
import "./position.css";
import DataGrid, { Column, ColumnChooser, ColumnFixing, Sorting, Scrolling, Format, HeaderFilter, FilterRow, Summary, TotalItem } from 'devextreme-react/data-grid';
import { LoadPanel } from 'devextreme-react/load-panel';
import { DateBox } from 'devextreme-react';
import NameCell from './NameCell.jsx';
import OperationCell from './OperationCell.jsx';
import DeltaPriceCell from './DeltaPriceCell.jsx';
import HeaderCell from './HeaderCell.jsx';
import Tooltip from "devextreme-react/tooltip";
import { on } from "devextreme/events";

import PieChart, {
    Legend,
    Series,
    Label,
    Connector,
    Export
} from 'devextreme-react/pie-chart';

import {
    Chart,
    CommonSeriesSettings,
    ArgumentAxis,
    ValueAxis,
    Margin,
    Title,
    Subtitle,
    Point
} from 'devextreme-react/chart';

export default class Position extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            positionItems: [],
            pieItems: [],
            rateItems: [],
            ioItems: [],
            rate: 0,
            profit: 0,
            profile: '',
            yield: 0,
            fromDate: null,
            toDate: null,
            objectId: null,
            objectType: null,
            positionInfo: '',
            minDate: new Date(2019, 0, 1),
            maxDate: new Date(2019, 9, 10),
            excelDownloadButtonVisible: false,
            currentInvestment: {}
        };

        this.updateData = this.updateData.bind(this);
        this.downloadData = this.downloadData.bind(this);
        this.onFromDateChanged = this.onFromDateChanged.bind(this);
        this.onToDateChanged = this.onToDateChanged.bind(this);
        this.onCellPrepared = this.onCellPrepared.bind(this);

    }

    customizeText(arg) {
        return `${arg.argumentText} (${arg.percentText})`;
    }

    componentDidMount() {
    }

    onFromDateChanged(e) {
        if (e.value < this.state.toDate) {
            this.setState({
                fromDate: e.value
            });

            this.updateData();
        }
    }


    onToDateChanged(e) {
        if (e.value > this.state.fromDate) {
            this.setState({
                toDate: e.value
            });

            this.updateData();
        }
    }

    updateData() {
        var positionData = {
            objectId: this.props.location.state.objectId,
            product: this.props.location.state.product,
            type: this.props.location.state.type,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate
        }

        var tokenKey = 'accessToken';

        var token = sessionStorage.getItem(tokenKey);


        fetch('api/main/position', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(positionData)
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    positionItems: data.items,
                    pieItems: data.pieItems,
                    rateItems: data.rateItems,
                    ioItems: data.ioItems,
                    rate: data.rate,
                    profit: data.profit,
                    profile: data.profile,
                    yield: data.yield,
                    objectId: positionData.objectId,
                    objectType: positionData.type,
                    positionInfo: data.positionInfo,
                    fromDate: data.fromDate,
                    toDate: data.toDate,
                    excelDownloadButtonVisible: data.excelDownloadButtonVisible
                });
            });
    }

    downloadData() {
        let arr = this.state.positionInfo.split(/\s+/)
        let portfolio = arr[1]
        let openDate = arr[3] + ' ' + arr[4]
        let currency = (arr[5] + ' ' + arr[6]).replace('(', '').replace(')', '')

        var data = {
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            portfolio: portfolio,
            openDate: openDate,
            currency: currency,
            rate: this.state.rate,
            positionItems: this.state.positionItems,
            yield: this.state.yield,
            ioItems: this.state.ioItems
        }

        var tokenKey = 'accessToken';
        var token = sessionStorage.getItem(tokenKey);

        fetch('api/excel/positiondownload', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                const filename = decodeURIComponent(response.headers.get('Content-Disposition').split(';')[1].trim().split('=')[1]).replace("UTF-8''", "")
                return response.blob().then(blob => ({ filename, blob }))
            })
            .then(({ filename, blob }) => {
                const url = window.URL.createObjectURL(new Blob([blob]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', filename)
                document.body.appendChild(link)
                link.click()
                link.parentNode.removeChild(link)
            });
    }


    onCellPrepared(e) {
        e.cellElement.style.alignment = "center";
        if (e.rowType === "data" && e.column.dataField === "isin" || e.column.dataField === "shortName") {
            on(e.cellElement, "mouseover", arg => {
                this.setState({
                    currentInvestment: e.data
                });
                this.tooltip.instance.show(arg.target);
            });

            on(e.cellElement, "mouseout", arg => {
                this.tooltip.instance.hide();
            });
        }
    }


    render() {

        var objectId = this.props.location.state.objectId;
        var type = this.props.location.state.type;

        if (objectId != this.state.objectId || type != this.state.objectType) {
            this.updateData();

            return (
                <LoadPanel
                    shadingColor={'rgba(0,0,0,0.4)'}
                    visible={true}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                />
            )
        }

        return (

            <Grid fluid className="positionGrid">
                <Row>
                    <Col lg={12}>
                        <div className="componentHeader">{this.state.positionInfo}</div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={4}>
                        <Panel header="Выбор периода">
                            <table width="100%">
                                <tr>
                                    <td>
                                        <DateBox value={this.state.fromDate} min={this.minDate} max={this.maxDate} onValueChanged={this.onFromDateChanged} width={"auto"} id="periodFrom"></DateBox>
                                    </td>
                                    <td>
                                        <DateBox value={this.state.toDate} min={this.minDate} max={this.maxDate} onValueChanged={this.onToDateChanged} width={"auto"} id="periodTo"></DateBox>
                                    </td>
                                </tr>
                            </table>
                        </Panel>
                    </Col>
                    <Col lg={2}>
                        <Panel header="Оценка портфеля">                           
                                <Textfit mode="multi" className="infoItem">
                                    {this.state.rate}
                                </Textfit>                                
                        </Panel>
                    </Col>
                    <Col lg={2}>
                        <Panel header="Доход за период">
                            <Textfit mode="multi" className="infoItem">{this.state.profit}</Textfit>
                        </Panel>
                    </Col>
                    <Col lg={2}>
                        <Panel header="Доходность">
                            <Textfit mode="multi" className="infoItem">{this.state.yield}</Textfit>
                        </Panel>
                    </Col>
                </Row>
                <Row>
                    <Col lg={8}>

                        <Panel header="Позиция">
                            <DataGrid className="positionGrid"
                                dataSource={this.state.positionItems}
                                allowColumnResizing={true}
                                columnAutoWidth={true}
                                showColumnLines={false}
                                showRowLines={true}
                                showBorders={false}
                                onCellPrepared={this.onCellPrepared}
                            >
                                <Sorting mode={'none'} />
                                <Scrolling mode={'standard'} />
                                <Column
                                    dataField={'shortName'}
                                    caption={''}
                                    cellRender={NameCell}
                                    headerCellRender={HeaderCell}
                                    minWidth={160}
                                   
                                />
                                <Column
                                    dataField={'isin'}
                                    caption={'ISIN'}
                                    headerCellRender={HeaderCell}
                                />
                                <Column
                                    dataField={'amount'}
                                    caption={'Количество'}
                                    headerCellRender={HeaderCell}
                                >
                                    <Format
                                        type="fixedPoint"
                                        precision={0}
                                    />
                                </Column>
                                <Column
                                    dataField={'balancePrice'}
                                    caption={'Цена покупки'}
                                    headerCellRender={HeaderCell}
                                >
                                    <Format
                                        type="fixedPoint"
                                        precision={2}
                                    />
                                </Column>
                                <Column
                                    dataField={'priceDelta'}
                                    caption={'Изменение цены'}
                                    cellRender={DeltaPriceCell}
                                    alignment={'center'}
                                    headerCellRender={HeaderCell}
                                    visible={false}
                                >
                                </Column>
                                <Column
                                    dataField={'price'}
                                    caption={'Текущая цена'}
                                    headerCellRender={HeaderCell}
                                >
                                    <Format
                                        type="fixedPoint"
                                        precision={2}
                                    />
                                </Column>
                                <Column
                                    dataField={'totalValue'}
                                    caption={'Оценка'}
                                    headerCellRender={HeaderCell}
                                    cellRender={NameCell}
                                >
                                    <Format
                                        type="fixedPoint"
                                        precision={2}
                                    />
                                </Column>
                                <Column
                                    dataField={'percent'}
                                    caption={'Доля'}
                                    headerCellRender={HeaderCell}
                                    cellRender={NameCell}
                                >
                                    <Format
                                        type="percent"
                                        precision={2}
                                    />
                                </Column>
                            </DataGrid>
                            <Tooltip ref={ref => this.tooltip = ref} position={'right'}>
                                <div className={'tooltipContent'}>
                                    {this.state.currentInvestment ? <div><b>Место хранения: </b>{this.state.currentInvestment.tradePlacementName}</div> : null} 
                                </div>
                            </Tooltip>

                        </Panel>
                        <Button
                            text="Скачать"
                            onClick={this.downloadData}
                            visible={this.state.excelDownloadButtonVisible}
                            icon="assets/excel_logo.png"
                            type='normal'
                            elementAttr={
                                {class: "excel-download-button"}
                            }
                        />
                    </Col>
                    <Col lg={4}>
                        <Grid fluid className="positionInfo">
                            <Row>
                                <Col lg={12}>
                                    <Panel header="Структура активов">
                                        <PieChart
                                            id={'pie'}
                                            type={'doughnut'}
                                            palette={'Soft Pastel'}
                                            resolveLabelOverlapping='shift'
                                            dataSource={this.state.pieItems}>
                                            <Legend
                                                visible={false}
                                            />
                                            <Series argumentField={'position'}>
                                                <Label
                                                    visible={true}
                                                    position={'columns'}
                                                    customizeText={this.customizeText}>
                                                    <Connector visible={true} width={0.5} />
                                                </Label>
                                            </Series>

                                        </PieChart>
                                    </Panel>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Panel header="График доходности (%)">
                                        <Chart
                                            type={'line'}
                                            dataSource={this.state.rateItems}                                            
                                        >
                                            <ArgumentAxis argumentType={'DateTime'}>
                                            </ArgumentAxis>
                                            <CommonSeriesSettings
                                                argumentField={'targetDate'}
                                                type={'line'}
                                            >
                                                <Point visible={false}></Point>
                                            </CommonSeriesSettings>
                                            <Legend visible={false}>

                                            </Legend>
                                            <Series
                                                valueField={'value'}                                                
                                            >                                            
                                     
                                                </Series>
                                            </Chart>                                                                                    
                                    </Panel>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Panel header="Вводы/выводы">
                                        <DataGrid
                                            dataSource={this.state.ioItems}
                                            allowColumnReordering={true}
                                            allowColumnResizing={true}
                                            columnAutoWidth={true}
                                            showColumnLines={false}
                                            showRowLines={true}
                                            showBorders={false}>
                                            <HeaderFilter visible={true} />
                                            <FilterRow visible={false} />
                                            <Column
                                                dataField={'operationDate'}
                                                caption={'Дата'}
                                                dataType={'date'}
                                            >
                                            </Column>
                                            <Column
                                                dataField={'operation'}
                                                caption={'Операция'}
                                                cellRender={OperationCell}
                                            >
                                            </Column>
                                            <Column
                                                dataField={'value'}
                                                caption={'Сумма'}>
                                                <Format
                                                    type="fixedPoint"
                                                    precision={2}
                                                />
                                            </Column>

                                            <Summary>
                                                <TotalItem
                                                    column={'value'}
                                                    summaryType={'sum'} displayFormat={'Сумма: {0}'}
                                                    valueFormat={{
                                                        type: 'fixedPoint',
                                                        precision: 2
                                                    }}
                                                >
                                                </TotalItem>
                                            </Summary>
                                        </DataGrid>
                                    </Panel>
                                </Col>
                            </Row>
                        </Grid>
                    </Col>
                </Row >
            </Grid >

        );
    }
};



// WEBPACK FOOTER //
// ./App/containers/position/position.jsx